import React, { Component, Fragment, type JSX } from 'react';
import { Input } from '../../../formik/Input';

interface InvoiceSectionProps {}

interface InvoiceSectionState {
  show: boolean;
}

/**
 * The invoice fields are initially hidden. All fields are
 * optional.
 */
export class InvoiceSection extends Component<InvoiceSectionProps, InvoiceSectionState> {

  constructor(props: InvoiceSectionProps) {
    super(props);
    this.state = {
      show: false,
    };
  }

  /**
   * Toggle the additional invoice fields.
   */
  public toggleInvoice(e: any): void {
    e.preventDefault();

    this.setState({
      show: !this.state.show,
    });
  }

  public render(): JSX.Element {
    const { show }: InvoiceSectionState = this.state;
    return (
      <Fragment>
        <a onClick={(e: any): void => this.toggleInvoice(e)}
          className="side-link m-3">
          Afwijkend factuuradres opgeven
        </a>
        <div className={`additional-fields px-3 ${show && 'show'}`}>
          <div className="row my-3">
            <div className="col-sm-6">
              <Input name="invoice.company" placeholder="Bedrijfsnaam"/>
            </div>
            <div className="col-sm-6">
              <Input name="invoice.contact" placeholder="Naam Contactpersoon"/>
            </div>
          </div>
          <div className="row my-3">
            <div className="col-sm-4">
              <Input name="invoice.postalCode" placeholder="Postcode"/>
            </div>
            <div className="col-sm-4">
              <Input name="invoice.houseNumber" type="number" placeholder="Huisnummer"/>
            </div>
            <div className="col-sm-4">
              <Input name="invoice.houseNumberSuffix" placeholder="Toevoeging"/>
            </div>
          </div>
          <div className="row my-3">
            <div className="col-sm-6">
              <Input name="invoice.street" placeholder="Straat"/>
            </div>
            <div className="col-sm-6">
              <Input name="invoice.city" placeholder="Plaats"/>
            </div>
          </div>
          <div className="row my-3">
            <div className="col-sm-12">
              <Input name="invoice.email" placeholder="E-mailadres"/>
            </div>
          </div>
        </div>
      </Fragment>
    );

  }

}
